/**
 * @description 路由配置文件
 * @created 2024/04/19 16:03:10
 */
import Vue from "vue"
import Router from "vue-router"
import { REGEX_INDEX_VUE } from "@/constants/regex"
import { title } from "../../package.json"

Vue.use(Router)

// 以下匹配规则为：一个文件夹包含了 index.vue 则判定为路由
// 需要注意的是，请不要在路由文件夹下创建多个 index.vue
const requireViews = require.context("@/views", true, /\.\/.+\/index\.vue?$/)

// 生成路由规则
const routes = []
requireViews.keys().forEach(key => {
  const component = requireViews(key).default
  const { name, meta } = component
  const path = `/${key.replace(REGEX_INDEX_VUE, "")}`
  routes.push({
    path: name === "Dashboard" ? "/" : path,
    name,
    meta,
    component
  })
})

// 所有路由都不匹配时，转到错误页
routes.push({
  path: "*",
  redirect: "/errors"
})

const router = new Router({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = `${title} - ${to.meta.title}`
  next()
})

export default router
